"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.squish = exports.fromAsync = exports.bieffect = exports.effectLeft = exports.effect = exports.applyEffect = exports.unwrapTask = exports.unwrap = exports.TE = exports.TA = exports.NEAR = exports.RAR = exports.O = exports.NEA = exports.IOE = exports.IO = exports.ET = exports.E = exports.AR = exports.AP = exports.pipe = void 0;
const tslib_1 = require("tslib");
const AP = tslib_1.__importStar(require("fp-ts/lib/Apply"));
exports.AP = AP;
const AR = tslib_1.__importStar(require("fp-ts/lib/Array"));
exports.AR = AR;
const E = tslib_1.__importStar(require("fp-ts/lib/Either"));
exports.E = E;
const ET = tslib_1.__importStar(require("fp-ts/lib/EitherT"));
exports.ET = ET;
const function_1 = require("fp-ts/lib/function");
Object.defineProperty(exports, "pipe", { enumerable: true, get: function () { return function_1.pipe; } });
const IO = tslib_1.__importStar(require("fp-ts/lib/IO"));
exports.IO = IO;
const IOE = tslib_1.__importStar(require("fp-ts/lib/IOEither"));
exports.IOE = IOE;
const NEA = tslib_1.__importStar(require("fp-ts/lib/NonEmptyArray"));
exports.NEA = NEA;
const O = tslib_1.__importStar(require("fp-ts/lib/Option"));
exports.O = O;
const RAR = tslib_1.__importStar(require("fp-ts/lib/ReadonlyArray"));
exports.RAR = RAR;
const NEAR = tslib_1.__importStar(require("fp-ts/lib/ReadonlyNonEmptyArray"));
exports.NEAR = NEAR;
const TA = tslib_1.__importStar(require("fp-ts/lib/Task"));
exports.TA = TA;
const TE = tslib_1.__importStar(require("fp-ts/lib/TaskEither"));
exports.TE = TE;
exports.unwrap = (either) => {
    if (E.isLeft(either)) {
        throw either.left;
    }
    return either.right;
};
exports.unwrapTask = (operation) => tslib_1.__awaiter(void 0, void 0, void 0, function* () { return exports.unwrap(yield operation()); });
exports.applyEffect = (op) => (input) => {
    op(input);
    return input;
};
/**
 * This is like map except it maintains the passthrough value. It is only there
 * to have a side effect, not change the response.
 */
exports.effect = (op) => (task) => function_1.pipe(task, TE.map(exports.applyEffect(op)));
exports.effectLeft = (op) => (task) => function_1.pipe(task, TE.mapLeft(exports.applyEffect(op)));
/**
 * This is like map except it maintains the passthrough value. It is only there
 * to have a side effect, not change the response.
 */
exports.bieffect = (opl, opr) => (task) => function_1.pipe(task, TE.bimap(exports.applyEffect(opl), exports.applyEffect(opr)));
/**
 * This is a comically simple wrapper for creating a TaskEither out of a function
 * that returns a Promise. It also assumes the `left` is of type `Error`.
 */
exports.fromAsync = (fn) => TE.tryCatch(fn, err => err);
exports.squish = (e) => (E.isLeft(e) ? e.left : e.right);
//# sourceMappingURL=fp.js.map